export default {
  blends: {
    validationMessage:{
      requiredMessage:'Este campo é obrigatório',
      isNumber:'Deve ser um número',
      isValidNumber:'Deve ser um número válido',
      noNegativeNumbers:'Não pode ser um número negativo',
      atLeastTwoProducts: 'São necessários pelo menos dois produtos',
    },
    exemptProducts: {
      eudrExemptProducts: 'Produtos Isentos de EUDR',
      addEUDRExemptProduct: 'Adicionar Produto Isento de EUDR',
      updateEUDRExemptProduct: 'Atualizar Produto Isento de EUDR',
      internalRefNumber: 'Número de Referência Interna',
      supplier: 'Fornecedor',
      containerID: 'ID do Contêiner',
      product: 'Produto',
      quantity: 'Quantidade',
      dateAdded: 'Data Adicionada',
      addProduct: 'Adicionar Produto',
      selectDate: 'Selecionar Data',
      addContainer: 'Adicionar Contêiner',
      containerInformation: 'Informações do Contêiner',
      supplierInformation: 'Informações do Fornecedor',
      supplierInformationTT:
        'Detalhes sobre a entidade que fornece bens ou serviços.',
      supplierTooltip:
        'Selecione o fornecedor da lista pré-registrada no sistema.',
      addnewSupplier: 'Adicionar Novo Fornecedor',
      internalReferenceNumberMustBeAlphanumeric:
        'O número de referência interna deve ser alfanumérico',
      netMassMustBeValid: 'A massa líquida deve ser válida',
      volumeMustBeNumeric: 'O volume deve ser numérico',
      subProduct: 'Subproduto',
      netMass: 'Massa Líquida',
      volume: 'Volume',
      productDetail: 'Detalhes do Produto',
      placeOfActivity: 'Local da Atividade',
      countryOfActivity: 'País da Atividade',
      countryOfEntry: 'País de Entrada',
      activity: 'Atividade',
      internalRefNo: 'Número de Referência Interna',
      name: 'Nome',
      email: 'E-mail',
      phoneNumber: 'Número de Telefone',
      country: 'País',
      status: 'Status',
      addNewSupplier: 'Adicionar Novo Fornecedor',
      availableForBlends: 'Disponível para Misturas',
      thisFieldIsRequired: 'Este campo é obrigatório.',
      enterSupplierFirstName: 'Insira o Nome do Fornecedor',
      enterSupplierLastName: 'Insira o Sobrenome do Fornecedor',
      enterEmailAddress: 'Insira o Endereço de E-mail',
      enterPhoneNumber: 'Insira o Número de Telefone',
      selectCountry: 'Selecione o País',
      firstNameIsRequired: 'O primeiro nome é obrigatório',
      lastNameIsRequired: 'O sobrenome é obrigatório',
      unAvailableForBlends: 'Indisponível para Misturas',
      exemptAddedSuccessfully:
        'Produto isento de EUDR foi adicionado com sucesso!',
      unExpectedErrorMsg:
        'Ocorreu um erro inesperado. Por favor, tente novamente.',
      availabilityStatusMsg:
        'O status de disponibilidade para misturas foi atualizado com sucesso.',
      updateProduct: 'Atualizar Produto',
      exemptUpdatedSuccessfully:
        'Produto isento de EUDR foi atualizado com sucesso!',
      invalidNumericValue: 'Valor numérico inválido',
      containerIDTT:
        'Este é um identificador único do Contêiner. Insira o ID do Contêiner abaixo.',
        actions: 'Ações',
    },
  
    blends: 'Misturas',
    blendSetting: 'Configurações da Mistura',
    createBlendDds: 'Criar Mistura Dds',
    country: 'País',
    countryTT: 'País',
    select: 'Selecionar',
    edurDueDeligenceStatus: 'Status de Due Diligence EUDR',
    dueDiligenceStatus: 'Status de Due Diligence',
    EUDRDeforestationStatusTT: 'Status de Desmatamento EUDR',
    dueDeligenceStatus: 'Status de Due Diligence',
    uploadedToEU: 'Carregado na UE',
    pending: 'Pendente',
    underReview: 'Em Revisão',
    compliant: 'Conforme',
    nonCompliant: 'Não Conforme',
    processingFarm: 'Processando Fazenda',
    analyzingDeforestation: 'Analisando Desmatamento',
    writingToBlockchain: 'Escrevendo na Blockchain',
    readyToProceed: 'Pronto para Prosseguir',
    mitigationRequired: 'Mitigação Necessária',
    viewReport: 'Visualizar Relatório',
    share: 'Compartilhar',
    copyAndCreateNew: 'Copiar e Criar Novo',
    remove: 'Remover',
    eudrRefNo: 'Nº de Referência EUDR/Interna',
    finalProduct: 'Título da Mistura & ID do Lote da Mistura',
    noOfIngredients: 'Nº de Ingredientes',
    farmsAndQuantity: 'Fazendas & Quantidade',
    actions: 'Ações',
    confirmDialog: {
      delete: {
        title: 'Excluir Mistura',
        message: 'Tem certeza de que deseja excluir esta Mistura?',
        confirmBtn: 'Confirmar',
        cancelBtn: 'Cancelar',
      },
    },
    searchBlend: 'Pesquisar Mistura por Produto Final',
    blendDuplicatedSuccessfully: 'Mistura duplicada com sucesso.',
    reportDeletedSuccessfully: 'Relatório excluído com sucesso.',
    
    blendSettings: {
      dashboard: 'Painel de Controle',
      blendSettings: 'Configurações de Misturas',
      importBlends: 'Importar Misturas',
      addNewBlend: 'Adicionar Nova Mistura',
      searchTitle: 'Buscar por Título da Mistura',
      view: 'Visualizar',
      edit: 'Editar',
      remove: 'Remover',
      farms: 'Fazendas',
      blendCode: 'Código da Mistura',
      blendTitle: 'Título da Mistura',
      description: 'Descrição',
      'finalProductName&Code': 'Nome e Código do Produto Final',
      dateAdded: 'Data Adicionada',
      actions: 'Ações',
      addBlend: 'Adicionar Configurações de Mistura',
      cancel: 'Cancelar',
      createBlend: 'Criar Mistura',
      generalData: 'Dados Gerais',
      generalDataTT: "Este rótulo mostra todos os dados na tela.",
      blendTitleTT: "O menu suspenso pode ser acessado clicando nele, o que revela uma lista de misturas disponíveis para seleção.",
      enterHere: 'Insira aqui',
      blendCodeTT: 'Código da Mistura',
      blendDescription: 'Descrição da Mistura',
      blendDescriptionTT: 'Descrição da Mistura',
      finalProductName: 'Nome do Produto Final',
      finalProductNameTT: 'Nome do Produto Final',
      finalProductCode: 'Código do Produto Final',
      finalProductCodeTT: 'Código do Produto Final',
      processType: 'Tipo de Processo',
      processTypeTT: 'Tipo de Processo',
      finalProductLotIdGen: 'Gerador de ID de Lote do Produto Final',
      finalProductLotIdGenTT: 'Gerador de ID de Lote do Produto Final',
      productDetails: 'Produtos da Mistura (Ingredientes)',
      productDetailsTT: 'Produtos da Mistura (Ingredientes)',
      selectType: 'Selecionar Tipo',
      startCount: 'Contador Inicial',
      resetCounterEach: 'Reiniciar Contador a Cada',
      enter: 'Inserir',
      staticText: 'Texto Estático',
      incrementalNumber: 'Número Incremental',
      year: 'Ano',
      month: 'Mês',
      date: 'Data',
      none: 'Nenhum',
      space: 'Espaço',
      '0001': '0001',
      resetCounter: 'Reiniciar contador a cada',
      selectSeparator: 'Selecionar Separador',
      previewLotId: 'Visualização do ID do Lote',
      blendProducts: 'Produtos da Mistura',
      blendProductsTT: 'Produtos da Mistura',
      product: 'Produto',
      productTT: 'Produto',
      selectProduct: 'Selecionar Produto',
      subProduct: 'Subproduto',
      subProductTT: 'Subproduto',
      selectSubProduct: 'Selecionar Subproduto',
      originCountry: 'País de Origem',
      originCountryTT: 'País de Origem',
      selectCountry: 'Selecionar País',
      percentage: 'Porcentagem',
      percentageTT: 'Porcentagem',
      addAnotherProduct: 'Adicionar Outro Produto',
      confirmation: 'Confirmação',
      createBlendMessage: 'Tem certeza de que deseja adicionar uma nova mistura?',
      updateBlendMessage: 'Tem certeza de que deseja atualizar esta mistura?',
      confirm: 'Confirmar',
      pleaseFillRequiredFields: 'Por favor, preencha os campos obrigatórios',
      lightRoast: 'Torra Clara',
      mediumRoast: 'Torra Média',
      mediumDarkRoast: 'Torra Média Escura',
      darkRoast: 'Torra Escura',
      validation: {
        titleRequired: 'O título é obrigatório',
        codeRequired: 'O código da mistura é obrigatório',
        descriptionRequired: 'A descrição é obrigatória',
        finalProductNameRequired: 'O nome do produto final é obrigatório',
        finalProductCodeRequired: 'O código do produto final é obrigatório',
        processTypeRequired: 'O tipo de processo é obrigatório',
        selectTypeRequired: 'O tipo é obrigatório',
        startCountRequired: 'O contador inicial é obrigatório',
        selectSeparatorRequired: 'O separador é obrigatório',
        finalProductLotIdGenRequired:
          'A geração do ID de lote do produto final é obrigatória',
        productRequired: 'O produto é obrigatório',
        subProductRequired: 'O subproduto é obrigatório',
        originCountryRequired: 'O país de origem é obrigatório',
        percentageRequired: 'A porcentagem é obrigatória',
        hundredPrecent: 'A soma total deve ser exatamente 100%',
        productSubproductDuplicatedMsg:
          'O produto e o subproduto estão duplicados',
      },
      mustSelectIncrementalNumber:
        'Pelo menos um número incremental é necessário',
      blendSettingsCreated:
        'As configurações da mistura foram criadas com sucesso.',
      blendSettingsNotCreated:
        'A criação das configurações da mistura não teve sucesso. Tente novamente com dados corretos.',
      confirmDiaglog: {
        delete: {
          title: 'Excluir',
          message:
            'Tem certeza de que deseja excluir estas configurações de mistura?',
          confirmBtn: 'Confirmar',
          cancelBtn: 'Cancelar',
        },
      },
      itemDeletedSuccessfully:
        'As configurações da mistura foram excluídas com sucesso',
      updateBlend: 'Atualizar Configurações de Mistura',
      save: 'Salvar',
      blendSettingsUpdated:
        'As configurações da mistura foram atualizadas com sucesso.',
      blendSettingsNotUpdated:
        'A atualização das configurações da mistura não teve sucesso. Tente novamente com dados corretos.',
      updateMessage: 'Tem certeza de que deseja atualizar esta mistura?',
      createMessage: 'Tem certeza de que deseja adicionar uma nova mistura?',
      finalProductCodeAlreadyExists: 'O código do produto final já existe',
      blendCodeAlreadyExists: 'O código da mistura já existe.',
      valueMustBeNumber: 'Este campo deve ser um número',
      valueMustBeNonNegative: 'Este campo deve ser maior que zero',
    },
    imports: {
      imports: 'Importações',
      blends: 'Misturas',
      createNewImport: 'Criar Nova Importação',
      importsBlends: 'Importar Misturas',
      createBlends: 'Criar Misturas',
      downloadTemplateInfo:
        'Baixe e use os modelos abaixo para importar geofences em massa.',
      selectTemplate: 'Selecionar Modelo',
      downloadXlsTemplate: 'Baixar Modelo de Importação XLS',
      downloadProductCodes: 'Baixar Códigos de Produtos',
      selectFileToUpload: 'Selecione um arquivo para enviar dados',
      orDragDrop: 'Ou arraste e solte arquivos aqui',
      removeFile: 'Remover Arquivo',
      importantNote: 'Nota Importante',
      templateNote:
        'Use os modelos fornecidos acima para envios em massa. Outros formatos resultarão em falha.',
      importData:'Certifique-se de que esses dados não serão preservados até que todos os status sejam bem-sucedidos.',
      fileUploadSuccess: 'Arquivo enviado com sucesso',
      invalidFileFormat: 'Formato de arquivo inválido. Envie um arquivo válido',
      pleaseSelectSource: 'Selecione pelo menos uma fonte',
      blendTitle: 'Título da Mistura',
      blendCode: 'Código da Mistura',
      finalProductCode: 'Código do Produto Final',
      finalProductName: 'Nome do Produto Final',
      status: 'Status',
      downloadCsvTemplate: 'Baixar Modelo de Importação CSV',
      dropHere: 'ou arraste e solte aqui',
      Importing: 'Importando...',
      modalMessage:
        'Seu arquivo enviado está sendo processado. Notificaremos quando o upload for concluído.',
      importXLSFormat: 'Importar Formato XLS',
      importCSVFormat: 'Importar Formato CSV',
      fileSelected: 'O arquivo foi selecionado com sucesso.',
      success: 'Dados importados com sucesso.',
      importCompleted: 'Importação Concluída',
      invalidHeaders: "Cabeçalhos de Arquivo Inválidos",
      headerMismatchErro: "O arquivo carregado deve conter os seguintes cabeçalhos",
      missingHeaders: "Cabeçalhos Faltantes",
      additionalHeaders: "Cabeçalhos Adicionais (não permitidos)"
    },
    history: {
      history: 'Histórico',
      fileName: 'Nome do Arquivo',
      importedOn: 'Importado em',
      status: 'Status',
      action: 'Ação',
      blends: 'Misturas',
      download: 'Baixar',
      success: 'Sucesso',
      failed: 'Falhou'
    },
    createBlends: {
      eudrDueDiligence: 'Due Diligence EUDR',
      createBlends: 'Criar Misturas',
      discard: 'Descartar',
      reject: 'Rejeitar',
      saveAndContinueLater: 'Salvar e Continuar Depois',
      generateReport: 'Gerar Relatório',
      generalData: 'Dados Gerais',
      blend: 'Mistura',
      selectBlend: 'Selecionar Mistura',
      blendCode: 'Código da Mistura',
      blendDescription: 'Descrição da Mistura',
      finalProduct: 'Produto Final',
      finalProductCode: 'Código do Produto Final',
      netMass: 'Massa Líquida',
      netMassTT: "Permite aos usuários inserir o valor do imposto sobre a massa líquida associado a um produto, remessa ou transação.",
      volume: 'Volume',
      volumeTT: "O rótulo é exibido de forma proeminente ao lado de um campo ou seção onde são apresentados ou inseridos dados relacionados ao volume, como em especificações de produtos ou formulários de envio.",
      blendLotId: 'ID do Lote da Mistura',
      blendLotIdTT: "Mostra o identificador único do lote de acordo com a configuração das definições de Blend para rastrear o lote de mistura.",
      finishedProductLotId: 'ID do Lote do Produto Final',
      finishedProductLotIdTT: "Insira o identificador único do lote para rastrear o lote final do produto.",
      enterHere: 'Insira Aqui',
      internalReferenceNumber: 'Número de Referência Interna',
      internalReferenceNumberTT: "Código de referência interno para fins de rastreamento.",
      eudrReferenceNumber: 'Número de Referência EUDR',
      eudrReferenceNumberTT: "Código de referência de conformidade com a EUDR (Regulamento de Desmatamento da União Europeia). Este será preenchido automaticamente se o usuário desejar fazer o upload para a EUDR após a criação do relatório.",
      companyId: 'ID da Empresa',
      companyIdTT: "Identificador da empresa associada a esta mistura.",
      activity: 'Atividade',
      domestic: 'Doméstico',
      import: 'Importação',
      export: 'Exportação',
      containerInformation: 'Informações do Contêiner',
      containerInformationTT: "Este é um identificador único do contêiner. Por favor, insira o ID do contêiner abaixo.",
      addContainer: 'Adicionar Contêiner',
      blendProduct: 'Produto da Mistura',
      blendProductTT: "Adicione vários produtos e subprodutos de produtos isentos de DDS/EUDR para criar uma mistura.",
      product: 'Produto',
      productTT: "Mostra aos usuários o produto escolhido a partir de uma lista de produtos disponíveis na Configuração de Mistura para processamento, análise ou relatórios dentro da aplicação, facilitando a entrada e gestão precisa de dados.",
      subProduct: 'Subproduto',
      subProductTT: "Mostra aos usuários os subprodutos escolhidos a partir dos disponíveis na Configuração de Mistura relacionados a um produto principal selecionado, facilitando a entrada e gestão detalhada de dados dentro da aplicação.",
      ddsId: 'ID DDS',
      containerId: 'ID do Contêiner',
      uniqueContainerId:"O ID do contêiner deve ser único",
      containerIdTT: "Identificador único para o contêiner que transporta esta mistura.",
      country: 'País',
      countryTT: "Escolha o país associado à origem ou destino da mistura.",
      search: 'Pesquisar',
      select: 'Selecionar',
      addAnotherProduct: 'Adicionar Outro Produto',
      customization: 'Personalização',
      recordsPerPage: 'Registros por Página',
      restoreDefault: 'Restaurar Padrão',
      apply: 'Aplicar',
      applyFilter:"Aplicar filtro",
      clearFilter:"Limpar filtro",
      status: {
        compliant: 'Conforme',
        nonCompliant: 'Não Conforme',
        uploadToEudr:"CARREGADO NO PORTAL DA UE",
        eudrExempt: "ISENTO DE EUDR",
      },
      table: {
        eudrInternalRef: 'EUDR / No. de Referência Interna',
        containerId: 'ID do Contêiner',
        product: 'Produto',
        farmsQuantity: 'Fazendas & Quantidade',
        submissionDate: 'Data de Envio',
        dueDiligenceStatus: 'Status de Due Diligence',
        availabilityForBlends: 'Disponibilidade para Misturas',
        pleaseSelectSource: 'Selecione pelo menos uma fonte',
      },
      productionPlaceTable: {
        productionPlaceAndFarmId: 'Local de Produção e ID da Fazenda',
        product: 'Produto',
        producerName: 'Nome do Produtor',
        addressOfProduction: 'Endereço de Produção',
        status: 'Status de Desmatamento EUDR',
        riskAssessment: 'Avaliação de Risco',
      },
      
      addNewSupplier: 'Adicionar Novo Fornecedor',
      addNewBlend: 'Adicionar Nova Mistura',
      placeOfActivity: 'Local de Atividade do Operador',
      placeOfActivityTT: "Especifique o país do operador onde as atividades são realizadas e o país onde o produto entra no mercado da UE. Esses detalhes são essenciais para garantir a conformidade com os requisitos da EUDR.",
      countryOfActivity: 'País de Atividade do Operador',      
      countryOfActivityTT: "Selecione o país onde ocorre esta atividade.",
      countryOfEntry: 'País de Entrada',
      countryOfEntryTT: "Selecione o país de entrada para os produtos importados.",
      pleaseSelectAtLeastOne: 'Selecione pelo menos um relatório de cada produto',
      blendCreatedSuccessfully: "Blend foi criado com sucesso.",
      blendCreateFailed: "Ocorreu um erro ao criar o blend.",
      blendUpdatedSuccessfully: "Blend foi atualizado com sucesso.",
      blendUpdateFailed: "Ocorreu um erro ao atualizar o blend.",
      blendDeletedSuccessfully: "Blend foi excluído com sucesso.",
      blendSavedSuccessfully: 'Blend foi salvo com sucesso.',
      blendUploadedToEUSuccessfully: "Blend foi carregado com sucesso na UE."
    },
    manageProducts: {
      addNewProduct: 'Adicionar Novo Produto',
      editProduct: 'Editar Produto',
      addNewSubProduct: 'Adicionar Novo Subproduto',
      editSubProduct: 'Editar Subproduto',
      productTitle: 'Título do Produto',
      subProductTitle: 'Título do Subproduto',
      typeTitle: 'Digite o Título',
      hsCode: 'Código HS',
      typeHSCode: 'Digite o Código HS',
      eudrDocumentCode: 'Código do Documento EUDR',
      selectEudrDocumentCode: 'Selecione o Código do Documento EUDR',
      makeSelection: 'Faça uma seleção',
      uploadCategoryImage: 'Carregar Imagem da Categoria',
      addImage: 'Adicionar Imagem',
      cancel: 'Cancelar',
      save: 'Salvar',
      back: 'Voltar',
      add: 'Adicionar',
      confirm: 'Confirmar',
      deleteMessage: 'Tem certeza de que deseja remover',
      invalidFileType: 'Tipo de Arquivo Inválido',
      errorUploadingFile:
        'Ocorreu um erro inesperado ao carregar o arquivo. Tente novamente mais tarde.',
      fileUploadFailed: 'Falha no Upload do Arquivo',
      selectDocumentCode: 'Selecione o Código do Documento',
      view: 'Visualizar',
      edit: 'Editar',
      remove: 'Remover',
      search: 'Pesquisar',
      searchByProductName: 'Pesquisar por Nome do Produto',
      eudrDueDiligence: 'Due Diligence EUDR',
      products: 'Produtos',
      subProducts: 'Subprodutos',
      fieldRequired: 'Este campo é obrigatório',
      fileRequired: 'Arquivo Obrigatório',
      fileRequiredMessage:
        'Carregue ou selecione um arquivo antes de salvar o produto.',
      addNewDocumentCode: 'Adicionar Novo Código do Documento',
      enterHere: 'Digite aqui',
      documentCode: 'Código do Documento',
      title: 'Título',
      description: 'Descrição',
      updateProduct: 'Atualizar Produto',
      updateSubProduct: 'Atualizar Subproduto',
      deleteSubProduct: 'Excluir Subproduto',
      deleteProduct: 'Excluir Produto',
      productAddedMessage: 'Produto adicionado com sucesso.',
      subProductAddedMessage: 'Subproduto adicionado com sucesso.',
      productUpdateMessage: 'Produto atualizado com sucesso.',
      subProductUpdateMessage: 'Subproduto atualizado com sucesso.',
      subProductDeleteMessage: 'Subproduto excluído com sucesso.',
      productDeleteMessage: 'Produto excluído com sucesso.',
      pleaseTryAgain: 'Algo deu errado. Tente novamente mais tarde.',
      documentCodeDuplicate: 'O código do documento já existe',
      unsupportedFileFormat: 'Tipo de arquivo não suportado. Por favor, envie um arquivo de imagem válido.',
      tableHeaders: {
        productName: 'Nome do Produto',
        hsCode: 'Código HS',
        eudrDocumentCode: 'Código do Documento EUDR',
        subProduct: 'Subprodutos',
        dateAdded: 'Data Adicionada',
        action: 'Ações',
      },
      documentCodeSaved: 'Código do Documento salvo com sucesso.',
    },
    finalReport: {
      title: 'Relatório Final de Misturas',
      reportStatus: 'Status do Relatório',
      blendTitle: 'Título da Mistura',
      blendCode: 'Código da Mistura',
      finalProduct: 'Produto Final',
      finalProductCode: 'Código do Produto Final',
      blendDescription: 'Descrição da Mistura',
      processType: 'Tipo de Processo',
      netMass: 'Massa Líquida',
      volume: 'Volume',
      blendLotId: 'ID do Lote da Mistura',
      finalProductLotId: 'ID do Lote do Produto Final',
      internalReferenceNumber: 'Número de Referência Interna',
      eudrReferenceNumber: 'Número de Referência EUDR',
      activity: 'Atividade',
      countryOfActivity: 'País da Atividade',
      countryOfEntry: 'País de Entrada',
      dueDiligenceReportStatus: 'Status do Relatório de Due Diligence',
      containerId: 'ID do Contêiner',
      operatorData: 'Dados do Operador',
      name: 'Nome',
      country: 'País',
      isoCode: 'Código ISO',
      eoriNumber: 'Número EORI',
      reportSummary: {
        title: 'Resumo do Relatório',
        totalDdsReports: 'Número Total de Relatórios DDS',
        totalGeofencePolygons: 'Número Total de Polígonos Geofence',
        totalGeofencePoints: 'Número Total de Pontos Geofence',
        totalDeforestationAssessments:
          'Número Total de Avaliações de Desmatamento',
        totalRiskAssessments: 'Número Total de Avaliações de Risco',
        totalFarms: 'Número Total de Fazendas',
        totalHighDeforestationFarms: 'Número de Fazendas com Alto Desmatamento',
        totalLowZeroRiskFarms: 'Número de Fazendas com Baixo ou Zero Risco',
        totalArea: 'Área Total (ha)',
        averageGeofenceArea: 'Área Média de Geofence (ha)',
        totalHighRiskFarmArea: 'Área Total de Fazendas de Alto Risco',
        totalLowZeroRiskFarmArea:
          'Área Total de Fazendas com Baixo ou Zero Risco',
        productionPlaces: 'Locais de Produção',
        productionPlacesTooltip: 'Detalhes sobre os locais de produção',
        declarationStatement: 'Declaração do Operador',
        declarationStatementTooltip: 'Declaração oficial do operador',
        declarationText1:
          '[Nome] {name}, declaro que todos os dados enviados com este envio são precisos ao melhor do meu conhecimento e crença.',
        declarationText2:
          'Eu, [Nome] {name}, afirmo que visitei as fazendas associadas a este envio e confirmo a conformidade delas com as leis e regulamentos locais sobre desmatamento.',
      },
      blendProducts: {
        title: 'Produtos da Mistura',
        product: 'Produto',
        subProduct: 'Subproduto',
        country: 'País',
        reference: 'EUDR / Número de Referência Interna',
        containerId: 'ID do Contêiner',
        farmsQuantity: 'Fazendas & Quantidade',
        submissionDate: 'Data de Envio',
        status: 'Status',
      },
      activityLog: {
        title: 'Registro de Atividades',
        user: 'Usuário',
        userRole: 'Função do Usuário',
        ipAddress: 'Endereço IP',
        dateTime: 'Data & Hora',
        segment: 'Segmento',
        activityDescription: 'Descrição da Atividade',
      },
      declaration: {
        title: 'Declaração do Operador',
        name: 'Nome',
        address: 'Endereço',
        dateTime: 'Data & Hora',
      },
      buttons: {
        discard: 'Descartar',
        reject: 'Rejeitar',
        edit: 'Editar',
        finalize: 'Finalizar',
        download: 'Baixar',
        uploadToEuPortal: 'Carregar no Portal da UE',
        submit: 'Enviar',
      },
    },
  }
};